declare global {
    interface RouterMeta {
        title: string;
    }

    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }

    interface System {
        import(request: string): Promise<any>
    }

    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') }
    ]
}
export const appRouters: Array<Router> = [{
    path: '/setting',
    name: 'setting',
    permission: '',
    meta: { title: '账号' },
    icon: "&#59275;",
    component: main,
    children: [
        {
            path: 'user',
            permission: 'Pages.Users',
            meta: { title: 'Users' },
            name: 'user',
            component: () => import('../views/setting/user/user.vue')
        },
        {
            path: 'role',
            permission: 'Pages.Roles',
            meta: { title: 'Roles' },
            name: 'role',
            component: () => import('../views/setting/role/role.vue')
        },
        {
            path: 'tenant',
            permission: 'Pages.Tenants',
            meta: { title: 'Tenants' },
            name: 'tenant',
            component: () => import('../views/setting/tenant/tenant.vue')
        }
    ]
}, {
    path: '/lottery',
    name: 'lottery',
    permission: '',
    meta: { title: '抽奖管理' },
    icon: "&#59210;",
    component: main,
    children: [
        {
            path: 'campaign',
            permission: 'Pages.Users',
            meta: { title: '活动' },
            name: 'campaign',
            component: () => import('../views/lottery/campaign/list.vue')
        },
        {
            path: 'package',
            permission: 'Pages.Users',
            meta: { title: '礼包' },
            name: 'package',
            component: () => import('../views/lottery/package/list.vue')
        },
        {
            path: 'gift',
            permission: 'Pages.Users',
            meta: { title: '奖品' },
            name: 'gift',
            component: () => import('../views/lottery/gift/list.vue')
        },
        {
            path: 'stock',
            permission: 'Pages.Users',
            meta: { title: '库存' },
            name: 'stock',
            component: () => import('../views/lottery/stock/list.vue')
        },
        {
            path: 'records',
            permission: 'Pages.Users',
            meta: { title: '明细' },
            name: 'records',
            component: () => import('../views/lottery/records/list.vue')
        }


    ]
}, {
    path: '/log',
    name: 'log',
    permission: '',
    meta: { title: '系统管理' },
    icon: "&#59177;",
    component: main,
    children: [
        {
            path: 'apilog',
            permission: 'Pages.Users',
            meta: { title: '接口日志' },
            name: 'apilog',
            component: () => import('../views/lottery/apilog/list.vue')
        }
    ]
}

]
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters
];
